//import liraries
import React, { Component, useEffect, useState, useRef } from "react";
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  Image,
  Dimensions,
  TextInput,
  Modal
} from "react-native";
import { CreateResponsiveStyle, DEVICE_SIZES, useDeviceSize,} from "rn-responsive-styles";


const rechargePattern = /^[1-9][0-9]*\.{0,1}[0-9]{0,2}$/;
// create a component
const isSmallDevice = Dimensions.get("window").width < 767;
const isTabView =
  Dimensions.get("window").width > 767 && Dimensions.get("window").width < 1024;


// define your styles
const useStyles = CreateResponsiveStyle(
  {
    mainContainer: {
      width: "100%",
      height: 400,
      backgroundColor: "#ffffff",
      borderRadius: 15,
      marginTop: 20,
      marginLeft: 20
    },
    iconContainer: {
      marginTop: "2%",
      flexDirection: isSmallDevice || isTabView ? "column" : "row",
      paddingLeft: 20,
      paddingHorizontal: isSmallDevice || isTabView ? null : 50,
      marginLeft: isSmallDevice || isTabView ? null : 10,
    },
    backIcon: {
      height: 19,
      width: 19,
      resizeMode: "center",
      opacity: 0.8,
    },
    overlayViewStyle: {
      position: "absolute",
      zIndex: 9999,
      backgroundColor: "rgba(52,52,52,0.9)",
      width: "100%",
      height: "100%",
      top: 0,
      left: 0,
      borderRadius: 15,
    },
    overlayContainer: {
      width: "100%",
      height: "100%",
      zIndex: 99999,
    },
    overlay: {
      width: "100%",
      height: "100%",
      justifyContent: "center",
      alignItems: "center",
    },
    loaderBg: {
      backgroundColor: "white",
      width: "50%",
      borderRadius: 20,
      justifyContent: "flex-start",
      alignItems: "center",
      shadowColor: "rgba(0,0,0,0.05)",
      shadowOpacity: 1.5,
      elevation: 12,
      shadowRadius: 20,
      shadowOffset: { width: 1, height: 13 },
    },
    overlayContentViewStyle: {
      width: 348.1,
      height: 269.7,
      borderRadius: 13,
      backgroundColor: "#ffffff",
      shadowColor: "rgba(0, 0, 0, 0.05)",
      shadowOffset: {
        width: 0,
        height: 27,
      },
      shadowRadius: 34,
      shadowOpacity: 1,
    },
    enterOtpTextStyle: {
      fontFamily: "Inter",
      fontSize: 16,
      fontWeight: "bold",
      fontStyle: "normal",
      lineHeight: 21,
      letterSpacing: 0.64,
      textAlign: "center",
      color: "#66625f",
      paddingTop: 20,
    },
    otpDescTextStyle: {
      opacity: 0.5,
      fontFamily: "Inter",
      fontSize: 14,
      fontWeight: "500",
      fontStyle: "normal",
      lineHeight: 16,
      letterSpacing: 0,
      textAlign: "center",
      color: "#02122c",
      paddingTop: 10,
      marginHorizontal: 30,
    },
    otpInputViewStyle: {
      width: 250.4,
      height: 38,
      backgroundColor: "rgba(0, 0, 0, 0)",
      borderStyle: "solid",
      borderWidth: 1.5,
      borderColor: "#dfdfdf",
      fontFamily: "Inter",
      fontSize: 18,
      fontWeight: "bold",
      fontStyle: "normal",
      lineHeight: 14,
      letterSpacing: 3.6,
      textAlign: "left",
      color: "#66625f",
      borderRadius: 5,
      marginTop: 20,
      alignSelf: "center",
      paddingLeft: 10,
    },
    resendViewStyle: {
      flexDirection: "row",
      justifyContent: "space-between",
      marginHorizontal: "15%",
      marginTop: 5,
    },
    timerTextStyle: {
      opacity: 0.5,
      fontFamily: "Inter",
      fontSize: 13,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 15,
      letterSpacing: 0,
      textAlign: "left",
      color: "#02122c",
    },
    resendTextStyle: {
      fontFamily: "Inter",
      fontSize: 13,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 15,
      letterSpacing: 0,
      textAlign: "left",
      color: "#bd2d37",
    },
    textStyle: {
      fontFamily: "Inter",
      fontSize: 13,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 15,
      letterSpacing: 0,
      textAlign: "left",
      color: "#999999",
      marginLeft: 10,
    },
    bitMap: {
      width: 51.5,
      height: 47,
      borderRadius: 10,
      backgroundColor: "#ccd0d5",
      resizeMode: "center",
      alignSelf: "center",
    },
    bodyStyle: {
      flexDirection: "row",
      marginHorizontal: "10%",
      marginTop: 20,
    },
    bodyViewStyle: {
      width: 320,
    },
    viewStyle: {
      flexDirection: "row",
      justifyContent: "space-between",
      marginBottom: 10,
    },
    selectedTextStyle: {
      fontFamily: "Inter",
      fontSize: 15,
      fontWeight: "600",
      fontStyle: "normal",
      lineHeight: 18,
      letterSpacing: 0.3,
      textAlign: "left",
      color: "#5f5f5f",
    },
    debitTextStyle: {
      fontFamily: "Inter",
      fontSize: 15,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 18,
      letterSpacing: 0,
      textAlign: "left",
      color: "#bbbbbb",
    },
    cardViewStyle: {
      width: "100%",
      height: 74,
      borderRadius: 10,
      shadowColor: "rgba(176, 176, 176, 0.2)",
      shadowOffset: {
        width: 0,
        height: 11,
      },
      shadowRadius: 17,
      shadowOpacity: 1,
      borderStyle: "solid",
      borderWidth: 1,
      borderColor: "#ccd0d5",
      flexDirection: "row",
      marginBottom: 15,
      paddingHorizontal: 10,
      alignItems: "center"
    },
    secondContainer: {
      marginLeft: "10%",
    },
    textInputStyle: {
      width: 204,
      height: 32.5,
      backgroundColor: "rgba(0, 0, 0, 0)",
      borderStyle: "solid",
      borderWidth: 2,
      borderColor: "#dfdfdf",
      borderRadius: 5,
      fontFamily: "Inter",
      fontSize: 16,
      fontWeight: "bold",
      fontStyle: "normal",
      lineHeight: 18,
      letterSpacing: 0.1,
      textAlign: "left",
      color: "#b6b7bf",
      marginTop: 10,
      paddingHorizontal: 20,
    },
    quickAddViewStyle: {
      flexDirection: "row",
      marginTop: 40,
      alignItems: "center",
    },
    quickAddTextStyle: {
      fontFamily: "Inter",
      fontSize: 12,
      fontWeight: "300",
      fontStyle: "normal",
      lineHeight: 19,
      letterSpacing: 0.36,
      textAlign: "left",
      color: "#757575",
      marginRight: 10,
    },
    quickRechargeViewStyle: {
      width: 64.9,
      height: 23.4,
      backgroundColor: "#ffdfe2",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: 15,
      marginHorizontal: 5,
    },
    amountTextStyle: {
      fontFamily: "Inter",
      fontSize: 10,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 12,
      letterSpacing: 0.34,
      textAlign: "left",
      color: "#9b1e27",
    },
    customButtonViewStyle: {
      width: 228.1,
      height: 37,
      marginTop: 50,
    },
    quickLinksViewStyle: { marginTop: -30 },
    viewStyle1: { marginLeft: 10, maxWidth: 100 },
    vrnTextStyle: {
      fontFamily: "Inter",
      fontSize: 9,
      fontWeight: "600",
      fontStyle: "normal",
      lineHeight: 11,
      letterSpacing: 0,
      textAlign: "left",
      color: "#02122c",
    },
    vehicleModalTextStyle: {
      opacity: 0.6,
      fontFamily: "Inter",
      fontSize: 9,
      fontWeight: "500",
      fontStyle: "normal",
      lineHeight: 11,
      letterSpacing: 0,
      textAlign: "left",
      color: "#02122c",
    },
    transferAmountTextStyle: {
      fontFamily: "Inter",
      fontSize: 13,
      fontWeight: "bold",
      fontStyle: "normal",
      lineHeight: 15,
      letterSpacing: 0,
      textAlign: "right",
      color: "#02122c",
      marginLeft: 60
    }
  },
  {
    [DEVICE_SIZES.LG]: {},
    [DEVICE_SIZES.MD]: {
      mainContainer: {
        width: "100%",
        height: 752,
      },
      bodyStyle: {
        flexDirection: "column",
        marginLeft: "10%",
      },
      secondContainer: {
        marginLeft: 0,
      },
      customButtonViewStyle: {
        alignSelf: "flex-end",
      },
    },
    [DEVICE_SIZES.SM]: {},
    [DEVICE_SIZES.XS]: {
      mainContainer: {
        width: "100%",
        height: 684,
        marginLeft: 0
      },
      bodyStyle: {
        flexDirection: "column",
        marginLeft: "10%",
      },
      secondContainer: {
        marginLeft: 0,
      },
      customButtonViewStyle: {
        alignSelf: "flex-end",
      },
      bodyViewStyle: {
        width: 247.7,
      },
      quickLinksViewStyle: { marginTop: 20 },
      transferAmountTextStyle: {
        marginLeft: 10,
        fontSize: 10
      },
      viewStyle1:{
        maxWidth:70
      }
    },
  }
);

//make this component available to the app
export default useStyles;
